import graphql from './graphql';

const query = /* GraphQL */ `
  query JobTitle_listWithCounts($statusFilter: StatusFilter) {
    JobTitle_listWithCounts(statusFilter: $statusFilter) {
      name
      numberOfEmployees
      Department {
        name
      }
      status
      id
      departmentId
      numberOfCourses
    }
  }
`;

/**
 * Obtiene la lista de puestos de trabajo con contadores
 * @param {Object} options - Opciones de filtrado
 * @param {('ACTIVE'|'INACTIVE'|'ALL')} options.statusFilter - Filtro por estado (por defecto: 'ALL')
 * @returns {Promise<Array>} Lista de puestos de trabajo
 */
const JobTitleListWithCounts = async (options = {}) => {
  const { statusFilter = 'ALL' } = options;

  return graphql(query, { statusFilter }).then(data => data?.JobTitle_listWithCounts || []);
};

export default JobTitleListWithCounts;
